import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { SessionRepository } from '@app-core/state/session.repository';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionRepo = inject(SessionRepository);
  const xToken = sessionRepo.getStoreProp('token_key');

  if (xToken) {
    req = req.clone({
      setHeaders: {
        'X-TOKEN': xToken,
      },
    });
  }

  return next(req);
};
